import React, { useState } from 'react';

interface MobileFeedbackPanelProps {
  onSubmit?: (feedback: { like: boolean | null; favorite: boolean; comment: string }) => void;
}

const MobileFeedbackPanel: React.FC<MobileFeedbackPanelProps> = ({ onSubmit }) => {
  const [like, setLike] = useState<boolean | null>(null);
  const [favorite, setFavorite] = useState(false);
  const [comment, setComment] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleFeedbackClick = (type: 'like' | 'dislike' | 'favorite') => {
    if (type === 'like') setLike(true);
    if (type === 'dislike') setLike(false);
    if (type === 'favorite') setFavorite(!favorite);
    setShowInput(true);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    if (onSubmit) {
      onSubmit({ like, favorite, comment });
    }
  };

  const handleCloseInput = () => {
    setShowInput(false);
  };

  if (submitted) {
    return (
      <div className="mobile-feedback-success">
        Thank you for your feedback! 💫
      </div>
    );
  }

  return (
    <>
      {/* Feedback Symbols - positioned at top left */}
      <div className="mobile-feedback-symbols-container">
        <button
          onClick={() => handleFeedbackClick('like')}
          className={`mobile-feedback-symbol ${like === true ? 'active' : ''}`}
        >
          👍
        </button>
        <button
          onClick={() => handleFeedbackClick('dislike')}
          className={`mobile-feedback-symbol ${like === false ? 'active' : ''}`}
        >
          👎
        </button>
        <button
          onClick={() => handleFeedbackClick('favorite')}
          className={`mobile-feedback-symbol ${favorite ? 'active' : ''}`}
        >
          ⭐
        </button>
      </div>
      
      {/* Feedback Input Modal */}
      {showInput && (
        <div className="mobile-feedback-modal-overlay" onClick={handleCloseInput}>
          <div className="mobile-feedback-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-feedback-modal-header">
              <h3>Share your feedback</h3>
              <button className="mobile-feedback-modal-close" onClick={handleCloseInput}>×</button>
            </div>
            <div className="mobile-feedback-modal-content">
              <textarea
                className="mobile-feedback-textarea"
                rows={3}
                placeholder="We appreciate your feedback! What did you enjoy or what could we do better?"
                value={comment}
                onChange={e => setComment(e.target.value)}
              />
              <button
                onClick={handleSubmit}
                className="mobile-feedback-submit"
              >
                Submit Feedback
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileFeedbackPanel; 